module.exports = __webpack_public_path__ + "img/saloncapitalfunding-white-text-only-powered.5171d2f6.png";